/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconSlice = createReactComponent("slice", "IconSlice", [
  ["path", { d: "M3 19l15 -15l3 3l-6 6l2 2a14 14 0 0 1 -14 4", key: "svg-0" }]
]);

export { IconSlice as default };
//# sourceMappingURL=IconSlice.js.map
